export default{
    orderDetail:{
        titleState:{
            title1:'采购订单',
            title2:'订单详情',
            title3:'面议'
        },
        stepState:{
            step1:'提交订单',
            step2:'商家确定',
            step3:'支付订单',
            step4:'商家发货',
            step5:'取消订单',
            step6:'商家备货',
            step7:'完成',
            step8:'时',
            step9:'分',
            step10:'秒',
            step11:'天',
            step12:'距离自动收货还剩'
        },
        msgState:{
            msg1:'支付剩余',
            msg2:'到期未支付系统将自动取消该订单',
            msg3:'订单编号：',
            msg4:'商家审核通过后可支付，商家审核拒绝，系统将自动取消订单',
            msg5:'订单金额：',
            msg6:'应付尾款金额：',
            msg7:'已付首笔款金额：',
        },
        btnState:{
            btn1:'确认收货',
            btn2:'取消订单',
            btn3:'确认自提',
            btn4:'删除订单',
            btn5:'订单详情',
            btn6:'取消订单',
            btn7:'立即付款',
            btn8:'售后详情',
            btn9:'申请退款',
            btn10:'支付尾款',
            btn11:'再次购买',
        },
        khxx:{
            khinfo1:'客户信息',
            khinfo2:'收货人：',
            khinfo3:'手机号：',
            khinfo4:'收货地址：',
        },
        peisong:{
            psInfo1:'配送信息',
            psInfo2:'收货地址：',
            psInfo3:'配送方式：',
            psInfo4:'卖家配送',
            psInfo5:'买家自提',
            psInfo6:'承运单位：',
            psInfo7:'配送单号：',
            psInfo8:'复制单号',
            psInfo9:'送货人：',
            psInfo10:'车船号码：',
            psInfo11:'查询详细进度',
            psInfo12:'自提点名称：',
            psInfo13:'自提点联系人：',
            psInfo14:'联系方式：',
            psInfo15:'提货地址：',
        },
        fukuan:{
            fkInfo1:'付款信息',
            fkInfo2:'支付类型：',
            fkInfo3:'首笔款支付方式：',
            fkInfo4:'首笔款付款时间：',
            fkInfo5:'尾款支付方式：',
            fkInfo6:'尾款付款时间：',
            fkInfo7:'付款凭证：',
            fkInfo8:'查看详情',
        },

        qxMassage:{
            qxInfo1:'订单取消信息',
            qxInfo2:'订单金额：',
            qxInfo3:'取消时间：',
            qxInfo4:'取消原因：',
        },
        table:{
            setp1:'商品',
            setp2:'规格：',
            setp3:'不合格率在',
            setp4:'% 及以内为正常收货；不合格率',
            setp5:'%之间，实行补损；不合格率在',
            setp6:'% 之间，采取降价收货；不合格率大于',
            setp7:'%，拒收或双方协议。',
            setp8:'验收标准',
            setp9:'数量',
            setp10:'单价',
            setp11:'小计',
            setp12:'买家留言：',
            setp13:'共计',
            setp14:'件商品',
            setp15:'商品总额：',
            setp16:'运费：',
            setp17:'订单金额：',

        },
        dialogState:{
            dil1:'取消订单',
            dil2:'订单取消成功后将无法恢复；如使用优惠券，优惠券将不再返还；支付优惠一并取消；已支付金额审核通过后，将原路返回支付账户。',
            dil3:'再想想',
            dil4:'提交',
            dil5:'订单跟踪',
            dil6:'配送企业：',
            dil7:'快递单号：',
            dil8:'付款凭证',
        },
        confirmState:{
            confirm1:'提示',
            confirm2:'确定',
            confirm3:'取消',
            confirm4:'已取消',
            confirm5:'是否确认申请验货异议？',
            confirm6:'是否确认再次购买？',
            confirm7:'是否确认货品已经收到且根据验收标准确认货品完好',
            confirm8:'确认收货后将不能申请验货异议服务？',
            confirm9:'已完成收货',
            confirm10:'是否删除该订单？',
            confirm11:'订单删除成功!',
            confirm12:'复制成功',
        },
        rulesMessage:{
            rule1:'请输入发票抬头！',
            rule2:'请输入2-50字的发票抬头！',
            rule3:'请输入15—20字符的纳税人识别码！',
            rule4:'请输入正确的纳税人识别号！',
            rule5:'请输入注册电话！',
            rule6:'请输入注册地址！',
            rule7:'请输入2-50字的注册地址！',
            rule8:'请输入开户银行!',
            rule9:'请输入4-10字的开户银行!',
            rule10:'请输入正确的开户银行!',
            rule11:'请输入收票人姓名！',
            rule12:'请输入2-10字的收票人姓名！',
            rule13:'请输入手机号码!',
            rule14:'请输入正确的11位手机号码!',
            rule15:'请选择所在地区!',
            rule16:'请输入详细地址信息!',
            rule17:'请输入4-50字的详细地址信息!',
        }

    }
    
}